import { styled, Tooltip, tooltipClasses, TooltipProps } from "@mui/material";

export const InfoTooltip = styled(
  ({ className, ...props }: TooltipProps & { className?: string }) => (
    <Tooltip
      {...props}
      arrow
      placement="top"
      classes={{ popper: className }}
      slotProps={{
        popper: {
          modifiers: [
            {
              name: "offset",
              options: {
                offset: [0, 5],
              },
            },
          ],
        }
      }}
    />
  ),
)(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    boxShadow: theme.shadows[2],
    borderRadius: "5px",
    padding: "10px",
    margin: "10px",
    fontSize: "14px",
    transition: "opacity 0.3s ease-in-out",
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.background.paper,
    transform: "rotate(180deg)",
    marginTop: "53px",
  },
}));
